import type { Theme } from "@mui/material"
import { TooltipTheme } from "core/themes/src/definitions/components.types"

export const createTooltipTheme = (theme: Theme): TooltipTheme => ({
    styleOverrides: {},
    variants: [
        {
            props: { variant: "light" },
            style: {
                ".MuiTooltip-tooltip .MuiTooltip-arrow::before": {
                    borderColor: theme.palette.highlight.main,
                },
                ".MuiTooltip-tooltip.MuiTooltip-tooltipArrow": {
                    borderColor: theme.palette.highlight.main,
                },
            },
        },
    ],
})
